import { render, staticRenderFns } from "./AddArtistWizardStepAddAnotherArtist.vue?vue&type=template&id=f831e04e&scoped=true&"
import script from "./AddArtistWizardStepAddAnotherArtist.vue?vue&type=script&lang=js&"
export * from "./AddArtistWizardStepAddAnotherArtist.vue?vue&type=script&lang=js&"
import style0 from "./AddArtistWizardStepAddAnotherArtist.vue?vue&type=style&index=0&id=f831e04e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f831e04e",
  null
  
)

export default component.exports